import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import Footer from "../components/Footer";

const ErrorComponent = () => {
  const { t } = useTranslation();

  useEffect(() => {
    document.title = "An Error Has Occurred";
  }, []);

  return (
    <>
      <main className="p-[1rem] md:p-[4rem]">
        <h1 className="text-center text-[2rem] font-minimoBold">
          {t("Error")}
        </h1>
        <div className="flex justify-center items-center my-[2rem] mx-auto flex-wrap w-full">
          <p>
            {t(
              "An error has occurred in the application. Please contact the Developer, refresh the page, or try again later."
            )}
          </p>
        </div>
      </main>
      <Footer />
    </>
  );
};

export default ErrorComponent;
